// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://ixbedeubwtzhdgiiszoi.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml4YmVkZXVid3R6aGRnaWlzem9pIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM1Mzc5NDMsImV4cCI6MjA3OTExMzk0M30.nZncF11kS798yRXAyKQLUWx5mQwZGqfctMrI39Ums28'

export const supabase = createClient(supabaseUrl, supabaseKey)